import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import BalancoService from '../../../../services/balanco-auth';
import { Link } from 'react-router-dom';



/*async function getBalancos() {
    let resposta = await fetch('http://localhost:3000/api/balancos.json')
    let nvlei = await resposta.json()
    return nvlei
}*/



const Balanco = () => {
    const [fundo, setFundo] = useState("");
    const [tipo, setTipo] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [arquivo, setArquivo] = useState([]);
    const [sucesso, setSucesso] = useState(false);
   // const [novosBalancos, setNovas] = useState([]);

    /*useEffect(() => {
         getBalancos().then(data => {
             setNovas(data['balancos'])
         })
     }, [])
 
     const enfiatudo = async () => {
         novosBalancos.map(async (item) => {
             const balanco = await BalancoService.cadastro(
                 {
                     cod_balanco: parseInt(item.cod_balancos),
                     fundo: item.fundo_balancos,
                     tipo: item.tipo_balancos,
                     ano: item.ano_balancos,
                     arquivo: item.arquivo_balancos
                 }
             )
             })}*/


    const handleUpload = (e) => setArquivo(e.target.files[0]);


    const montaForm = async () => {
        const balanco = new FormData();
        balanco.append("fundo", fundo)
        balanco.append("tipo", tipo)
        balanco.append("ano", ano)
        balanco.append("arquivo", arquivo);
        return balanco
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const balanco = await BalancoService.cadastro(dados)
            if (balanco.data["cod_balanco"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setFundo("")
        setTipo("")
        setAno("")
        setArquivo("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                {/*<Button onClick={enfiatudo}>Importar Balanços</Button>*/}
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col>
                            <Form.Group className="mb-3" controlId="fundo">
                                <FloatingLabel
                                    label="Fundo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="fundo"
                                        name="fundo"
                                        onChange={e => setFundo(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Consolidado">Consolidado</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal de Habitação">Fundo Municipal de Habitação</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                        <option value="Fundo Municipal dos Direitos da Criança e dos Adolescentes">Fundo Municipal dos Direitos da Criança e dos Adolescentes</option>
                                        <option value="Prefeitura Municipal">Prefeitura Municipal</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="tipo">
                                <FloatingLabel
                                    label="Tipo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="tipo"
                                        name="tipo"
                                        onChange={e => setTipo(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Financeiro">Financeiro</option>
                                        <option value="Orçamentário">Orçamentário</option>
                                        <option value="Patrimonial">Patrimonial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2026">2026</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="arquivo">
                                <Form.Label>Arquivo</Form.Label>
                                <Form.Control
                                    required
                                    type="file"
                                    name="arquivo"
                                    onChange={handleUpload}
                                    accept="application/pdf"

                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/balanco'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Balanço cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/balanco/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Balanços
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/balanco'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Balanco;